import React from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import { Link } from 'react-router-dom';
import singlePageStyles from '../common/SinglePage.module.scss';
import Layout from '../global/Layout';
import { useTranslation } from 'react-i18next';

const ForgotPasswordPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <div className={singlePageStyles.wrapper}>
        <h1>{t('pages.forgotPassword.title')}</h1>

        <ForgotPasswordForm />

        <div className={singlePageStyles.otherActions}>
          <Link to='/login'>{t('pages.forgotPassword.otherActions.login')}</Link>
          <Link to='/register'>{t('pages.forgotPassword.otherActions.register')}</Link>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPasswordPage;
